import React, { useState, useEffect } from 'react';
import BottomNav from '../components/BottomNav';
import Modal from '../components/Modal';

const BespokeAuctions = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [bidAmount, setBidAmount] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const auctions = [
    {
      id: 1,
      title: '24K Gold Bars (1KG)',
      image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=400&h=300&fit=crop',
      startingBid: '1,000,000',
      endTime: '2025-04-15T20:00:00',
      minBid: 1000000
    },
    {
      id: 2,
      title: 'Lamborghini Aventador SVJ',
      image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=400&h=300&fit=crop',
      startingBid: '7,500,000',
      endTime: '2025-04-20T22:00:00',
      minBid: 7500000
    }
  ];

  const [countdowns, setCountdowns] = useState({});

  useEffect(() => {
    const updateCountdowns = () => {
      const newCountdowns = {};
      auctions.forEach(auction => {
        const endTime = new Date(auction.endTime).getTime();
        const now = new Date().getTime();
        const timeLeft = endTime - now;

        if (timeLeft > 0) {
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          newCountdowns[auction.id] = `${days}d ${hours}h ${minutes}m`;
        } else {
          newCountdowns[auction.id] = 'Auction Ended';
        }
      });
      setCountdowns(newCountdowns);
    };

    updateCountdowns();
    const interval = setInterval(updateCountdowns, 60000);
    return () => clearInterval(interval);
  }, []);

  const openBidModal = (auction) => {
    setSelectedItem(auction);
    setBidAmount(auction.minBid.toString());
    setShowModal(true);
  };

  const submitBid = () => {
    if (bidAmount && parseInt(bidAmount) >= selectedItem.minBid) {
      setShowModal(false);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } else {
      alert('Please enter a valid bid amount');
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Bespoke Luxury Auctions</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Discover exclusive high-end items available for auction</p>

        {showSuccess && (
          <div className="alert alert-success">
            ✅ Bid successfully placed!
          </div>
        )}

        <div className="content-section">
          {auctions.map((auction) => (
            <div key={auction.id} className="auction-item">
              <img src={auction.image} alt={auction.title} className="auction-image" />
              <div className="auction-info">
                <h3 className="auction-title">{auction.title}</h3>
                <p>Starting Bid: <strong>R{auction.startingBid}</strong></p>
                <p>Time Left: <span className="countdown">{countdowns[auction.id]}</span></p>
                <button 
                  className="btn btn-primary mt-md"
                  onClick={() => openBidModal(auction)}
                >
                  Place Bid
                </button>
              </div>
            </div>
          ))}
        </div>

        <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
          <h3 className="modal-header">{selectedItem?.title}</h3>
          <div className="form-group">
            <label className="form-label">Enter Your Bid Amount (R):</label>
            <input
              type="number"
              className="form-input"
              min={selectedItem?.minBid}
              value={bidAmount}
              onChange={(e) => setBidAmount(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" onClick={submitBid}>
            Place Bid
          </button>
        </Modal>
      </div>

      <BottomNav />
    </div>
  );
};

export default BespokeAuctions;
